module.exports = __webpack_public_path__ + "img/title_no.b8ec33ba.svg";